/**
 * useLocalization — thin wrapper around react-i18next's useTranslation.
 * Provides a consistent `t()` function for all components.
 *
 * Mirrors Flutter's AppLocalization.translate() / translateString().
 */
import { useTranslation } from 'react-i18next';

export function useLocalization() {
  const { t, i18n } = useTranslation();
  return { t, i18n };
}
